import * as React from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m14.688 3.288-1.152 1.176 6.72 6.72H.6v1.632h19.656l-6.72 6.72 1.152 1.176L23.4 12z" }));
export default SvgArrowRight;
